var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-wrapper',_vm._g(_vm._b({attrs:{"component":_vm.VCard},scopedSlots:_vm._u([{key:"default",fn:function(){return [_vm._t("default")]},proxy:true},{key:"progress",fn:function(){return [_vm._t("progress")]},proxy:true}],null,true)},'base-wrapper',_vm.mergedAttrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }